import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { showToast } from 'shared/ui'
import { logger } from 'shared/lib'
import { FeatureRestrictedModalContent } from 'entities/UsersPermissions/ui/FeatureRestrictedModal/ui/FeatureRestrictedModalContent'
import { UsersApi } from 'entities/Users'
import { type IKeysUserPermissions } from 'entities/UsersPermissions'
import {
  userPermissionRequestTitle,
  userPermissionTitle,
} from 'entities/UsersPermissions/api/types'

export class FeatureRestrictedModalStore {
  private readonly _userPermission: IKeysUserPermissions | null = null

  constructor(userPermission: IKeysUserPermissions, onCloseCallback?: () => void) {
    makeAutoObservable(this)

    this._userPermission = userPermission

    this.openModal(
      userPermissionTitle[this._userPermission] || this._userPermission,
      onCloseCallback
    )
  }

  _idModal = ''
  onCloseCallback: (() => void) | null = null

  closeModal = () => {
    modalStore.removeModal(this._idModal)
  }

  openModal = (desc: string, onCloseCallback?: () => void) => {
    this._idModal = nanoid()
    this.onCloseCallback = onCloseCallback || null

    modalStore.addModal({
      id: this._idModal,
      showCloseIcon: false,
      showHeader: false,
      ModalContentProps: {
        desc,
      },
      ModalContent: FeatureRestrictedModalContent,
      closeText: 'Close',
      onClose: () => {
        this.closeModal()
        this.onCloseCallback?.()
      },
      primaryAction: {
        text: 'Request access',
        onAction: async () => {
          await this.updateChangeRoleRequest()
          this.closeModal()
          this.onCloseCallback?.()
        },
      },
    })
  }

  updateChangeRoleRequest = async () => {
    try {
      if (!this._userPermission) return

      await UsersApi.updateChangeRoleRequest()

      const permissionTitle =
        userPermissionRequestTitle[this._userPermission] ?? this._userPermission

      showToast({
        type: 'success',
        title: `${permissionTitle} request sent`,
      })
    } catch (e) {
      logger.error(e)

      showToast({
        type: 'error',
        title: 'Something went wrong. Please try again',
      })
    }
  }
}
